import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule
  ]
})
export class LoginComponent implements OnInit {
  public isLogin: boolean = true;
  public isRutDni: boolean = true;
  public isRestorePass: any = false;
  public labelDocumento: string = 'RUT';
  public placeholderDocumento: string = '16123456-K';
  public mensajeRequerido: string = 'RUT es requerido.';
  public mostrarContrasena: boolean = false;
  public loginForm: FormGroup;

  constructor(
    private readonly _router: Router,
    private readonly _formBuilder: FormBuilder,
  ) {
    this.loginForm = this._formBuilder.group({
      username: new FormControl('', {
        validators: Validators.required,
      }),
      password: new FormControl('', {
        validators: Validators.required,
      }),
    });
  }

  ngOnInit(): void {
    
  }

  async onLogin(etapa: string) {
    this.goHome();
  }

  goHome() {
    this._router.navigate(['/home']);
  }
}
